$ ->
  COMPLICATIONS_OTHER = 'Other'

  # Handle complications dropdown selection
  $('body').on 'change', '.complications-select', ->
    select = $(this)
    chosenContainer = select.next('.chosen-container')
    chosenSingle = chosenContainer.find('.chosen-single')

    if select.val() == COMPLICATIONS_OTHER
      # Convert the chosen dropdown to text input mode
      setTimeout ->
        convertToTextInput(select, chosenContainer, chosenSingle)
      , 10
    else if chosenContainer.hasClass('text-input-mode')

      currentValue = select.val()
      predefinedValues = ['', 'Grade I', 'Grade II', 'Grade IIIa', 'Grade IIIb', 'Grade IVa', 'Grade IVb', 'Grade V']

      if $.inArray(currentValue, predefinedValues) != -1
        # User selected a predefined option - clear text input and restore dropdown
        textInput = chosenSingle.find('.complications-text-input')
        if textInput.length > 0
          textInput.val('')

        # Store the new selected value before restoring dropdown mode
        newValue = currentValue

        select.val(newValue)

        # Clear text input mode class and restore proper Chosen.js structure
        chosenContainer.removeClass('text-input-mode')

        # Remove text input and restore the span structure that Chosen.js expects
        textInput = chosenSingle.find('.complications-text-input')
        if textInput.length > 0
          textInput.remove()

        # Restore the basic Chosen.js single structure if it's missing
        if chosenSingle.find('span').length == 0
          chosenSingle.html('<span></span><div><b></b></div>')

        # Completely destroy and reinitialize Chosen.js to get clean state
        setTimeout ->
          select.trigger('chosen:destroy')

          # Reinitialize with proper configuration
          chosenOptions =
            allow_single_deselect: true
            disable_search_threshold: 10
            width: '100%'

          select.chosen(chosenOptions)

          # Let Chosen.js build its structure completely, then ensure correct display
          setTimeout ->
            select.trigger('chosen:updated')
          , 100
        , 10
      # If it's not a predefined value, it's just the user typing - do nothing
    else if !chosenContainer.hasClass('text-input-mode')
      restoreDropdownMode(chosenContainer)

  window.convertToTextInput = (select, chosenContainer, chosenSingle) ->
    # Clear existing content
    chosenSingle.empty()

    # Clear any "result-selected" classes from dropdown options
    chosenContainer.find('.result-selected').removeClass('result-selected')

    # Create text input element
    textInput = $('<input>', {
      type: 'text'
      class: 'complications-text-input'
      placeholder: 'Type custom complication details...'
      value: ''
    })

    # Add text input to chosen container
    chosenSingle.append(textInput)
    chosenContainer.addClass('text-input-mode')

    # Ensure input is focusable and focus it
    setTimeout ->
      textInput.attr('tabindex', '0')
      textInput[0].focus()
      textInput[0].click()
    , 100

    # Handle text input changes
    textInput.off('input').on 'input', ->
      val = $(this).val().trim()
      if val != ''
        select.val(val)
      else
        select.val(COMPLICATIONS_OTHER)
      # Trigger change to ensure Rails form helpers pick up the value
      select.trigger('change')

    # Handle blur to ensure value is saved
    textInput.off('blur').on 'blur', ->
      val = $(this).val().trim()
      if val != ''
        select.val(val)
      else
        select.val(COMPLICATIONS_OTHER)
      select.trigger('change')

    # Handle form submission to ensure value is saved
    textInput.closest('form').off('submit.complications').on 'submit.complications', ->
      currentVal = textInput.val().trim()

      if textInput.is(':visible') && currentVal != ''
        select.val(currentVal)

      # Ensure the select field is not disabled and has proper name
      select.prop('disabled', false)
      select.attr('name', 'logbook_entry[complications]')

      # Create a backup hidden field to ensure the value gets submitted
      form = textInput.closest('form')
      existingHidden = form.find('input[name="logbook_entry[complications]"]')
      existingHidden.remove()

      if currentVal != ''
        hiddenField = $('<input type="hidden" name="logbook_entry[complications]">')
        hiddenField.val(currentVal)
        form.append(hiddenField)

      return true    # Handle escape key to go back to dropdown
    textInput.off('keydown').on 'keydown', (e) ->
      if e.keyCode == 27  # Escape key
        e.preventDefault()
        window.restoreDropdownMode(chosenContainer)
        select.val('')
        select.trigger('chosen:updated')

    # Handle clicks to ensure focus
    textInput.off('click').on 'click', (e) ->
      e.stopPropagation()
      $(this)[0].focus()

  window.restoreDropdownMode = (chosenContainer) ->
    chosenContainer.removeClass('text-input-mode')
    select = chosenContainer.prev('select')
    currentValue = select.val()

    # Only clear text input elements if the selected option is NOT "Other"
    if currentValue != 'Other'
      chosenContainer.find('.complications-text-input').remove()

    # Clear any multiple "result-selected" classes before refreshing
    chosenContainer.find('.result-selected').removeClass('result-selected')

    # Refresh chosen
    select.trigger('chosen:updated')

    # Immediately clear "Other" option's result-selected class after chosen update
    setTimeout ->
      chosenContainer.find("[data-option-array-index]").each ->
        option = $(this)
        optionValue = select.find('option').eq(option.data('option-array-index')).val()
        if optionValue == 'Other'
          option.removeClass('result-selected')
    , 1

    # Force Chosen.js to rebuild the display completely for non-Other options
    if currentValue && currentValue != '' && currentValue != 'Other'
      setTimeout ->
        # Clear multiple selected classes again
        chosenContainer.find('.result-selected').removeClass('result-selected')

        # Force a complete refresh by temporarily changing and restoring the value
        select.val('')
        select.trigger('chosen:updated')

        setTimeout ->
          select.val(currentValue)
          select.trigger('chosen:updated')

          # Ensure only the correct option has result-selected class
          setTimeout ->
            chosenContainer.find('.result-selected').removeClass('result-selected')

            # Specifically ensure "Other" option is not selected when switching to another option
            chosenContainer.find("[data-option-array-index]").each ->
              option = $(this)
              optionValue = select.find('option').eq(option.data('option-array-index')).val()

              option.removeClass('result-selected')

              # Only add selected class to the current option (not "Other")
              if optionValue == currentValue && optionValue != 'Other'
                option.addClass('result-selected')
          , 10
        , 10
      , 50

  # Initialize on page load for existing custom values
  $(document).ready ->
    # Wait for Chosen.js to initialize before checking for custom values
    setTimeout ->
      $('.complications-select').each ->
        select = $(this)
        currentVal = select.val()
        predefinedValues = ['', 'Grade I', 'Grade II', 'Grade IIIa', 'Grade IIIb', 'Grade IVa', 'Grade IVb', 'Grade V', 'Other']

        if currentVal && $.inArray(currentVal, predefinedValues) == -1
          # This is a custom value - convert to text input
          chosenContainer = select.next('.chosen-container')
          if chosenContainer.length > 0
            chosenSingle = chosenContainer.find('.chosen-single')
            customValue = currentVal

            # Set dropdown to "Other" first and update chosen
            select.val(COMPLICATIONS_OTHER)
            select.trigger('chosen:updated')

            # Wait for chosen update to complete, then convert to text input
            setTimeout ->
              window.convertToTextInput(select, chosenContainer, chosenSingle)
              # Set the custom value in the text input after it's created
              setTimeout ->
                textInput = chosenSingle.find('.complications-text-input')
                if textInput.length > 0
                  textInput.val(customValue)
                  select.val(customValue)
              , 50
            , 100
    , 500

  # Also handle initialization when Chosen.js triggers its ready event
  $('body').on 'chosen:ready', '.complications-select', ->
    select = $(this)
    currentVal = select.val()
    predefinedValues = ['', 'Grade I', 'Grade II', 'Grade IIIa', 'Grade IIIb', 'Grade IVa', 'Grade IVb', 'Grade V', 'Other']

    if currentVal && $.inArray(currentVal, predefinedValues) == -1
      chosenContainer = select.next('.chosen-container')
      if chosenContainer.length > 0
        chosenSingle = chosenContainer.find('.chosen-single')
        customValue = currentVal

        select.val(COMPLICATIONS_OTHER)
        select.trigger('chosen:updated')

        setTimeout ->
          window.convertToTextInput(select, chosenContainer, chosenSingle)
          setTimeout ->
            textInput = chosenSingle.find('.complications-text-input')
            if textInput.length > 0
              textInput.val(customValue)
              select.val(customValue)
          , 50
        , 100
